import { render, staticRenderFns } from "./reminderTime.vue?vue&type=template&id=62deabe6&scoped=true&"
import script from "./reminderTime.vue?vue&type=script&lang=ts&"
export * from "./reminderTime.vue?vue&type=script&lang=ts&"
import style0 from "./reminderTime.vue?vue&type=style&index=0&id=62deabe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62deabe6",
  null
  
)

export default component.exports